<form [formGroup]="form" class="baseline-package-step">
  <div class="baseline-package-info">
    <h3 class="baseline-package-name">{{ packageNameLabel }}</h3>
    <p class="baseline-package-description">{{ packageDescription }}</p>
  </div>

  <div class="fee-table">
    <div class="fee-table-row" *ngFor="let item of feeLineItems">
      <div class="fee-table-item">
        <span class="fee-table-item-label">{{ item.label }}</span>
        <span class="fee-table-item-description">{{ item.description }}</span>
      </div>
      <span class="fee-table-item-amount">{{ item.amountDisplay }}</span>
    </div>
  </div>

  <div class="total-row">
    <span class="total-row-label">{{ feeTotalLabel }}</span>
    <span class="total-row-amount">{{ feeAmountDisplay }}</span>
  </div>

  <app-confirmation-checkbox
    [control]="form.controls.confirmed"
    [label]="confirmationLabel"
    [required]="true"
    [errorText]="
      'SERVICE_PLAN.VALIDATION.BASELINE_PACKAGE_CONFIRMATION_REQUIRED'
        | translate
    "
  />
</form>
